import React from 'react';
import classNames from 'classnames';
import { Text } from '@deriv/components';
import { TCompareAccountsCard } from 'Components/props.types';
import { getPlatformLabel, getHeaderColor, platfromsHeaderLabel } from '../../Helpers/compare-accounts-config';

const CFDCompareAccountsPlatformLabel = ({ trading_platforms }: TCompareAccountsCard) => {
    const platform_label = getPlatformLabel(trading_platforms.platform);
    const header_color = getHeaderColor(platform_label);

    return (
        <div
            className={classNames('compare-cfd-account-platform-label', {
                'compare-cfd-account-platform-label--other-cfds': platform_label === platfromsHeaderLabel.other_cfds,
            })}
        >
            <Text as='p' weight='bold' size='xxxs' align='center' color={header_color}>
                {platform_label}
            </Text>
        </div>
    );
};

export default CFDCompareAccountsPlatformLabel;
